import { css } from 'styled-components'
import { FontSizeEnum } from '@/constants/font-size.enum'
import { LineHeightEnum } from '@/constants/line-height.enum'

const fontLetterSpacing = '-0.02em'

const heading = {
  h1: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.H1};
    font-weight: ${(props) => props.theme.fontWeight.bold};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.H1};
  `,
  h2: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.H2};
    font-weight: ${(props) => props.theme.fontWeight.bold};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.H2};
  `,
  h3: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.H3};
    font-weight: ${(props) => props.theme.fontWeight.bold};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.H3};
  `,
  h4: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.H4};
    font-weight: ${(props) => props.theme.fontWeight.bold};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.H4};
  `,
  h5: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.H5};
    font-weight: ${(props) => props.theme.fontWeight.bold};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.H5};
  `,
  h6: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.H6};
    font-weight: ${(props) => props.theme.fontWeight.bold};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.H6};
  `,
}

const body = {
  body1: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.Body1};
    font-weight: ${(props) => props.theme.fontWeight.regular};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.Body1};
  `,
  body2: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.Body2};
    font-weight: ${(props) => props.theme.fontWeight.regular};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.Body2};
  `,
  body3: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.Body3};
    font-weight: ${(props) => props.theme.fontWeight.regular};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.Body3};
  `,
  body4: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.Body4};
    font-weight: ${(props) => props.theme.fontWeight.regular};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.Body4};
  `,
  body5: css`
    margin-top: 0;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.Body5};
    font-weight: ${(props) => props.theme.fontWeight.regular};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.Body5};
  `,
}

const caption = {
  caption1: css`
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.Caption1};
    font-weight: ${(props) => props.theme.fontWeight.regular};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.Caption1};
  `,
  caption2: css`
    color: ${(props) => props.theme.color.gray900};
    font-size: ${FontSizeEnum.Caption2};
    font-weight: ${(props) => props.theme.fontWeight.regular};
    letter-spacing: ${fontLetterSpacing};
    line-height: ${LineHeightEnum.Caption2};
  `,
}

/**
 * @deprecated 더이상 사용하지 않음
 */
export const FontStyles = {
  ...heading,
  ...body,
  ...caption,
}
